import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Role} from '../../../graphql/auth';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlRole} from '../getRole.api';

interface DeleteRoleVars {
    id: number
}

interface DeleteRoleData {
    deleteRole: Role
}

export const DELETE_ROLE_MUTATION = gql`
    mutation deleteRole($id: Int!) {
        deleteRole(id: $id) {
            ${gqlRole}
        }
    }
`;

export const deleteRole = () => useMutation<DeleteRoleData, DeleteRoleVars>(
    DELETE_ROLE_MUTATION,
    {
        update: updateCacheByType('Role'),
    }
);

export default deleteRole;